<template>
  <div>
    <div class="mycontainer" style="margin-bottom: 0px">
      <el-form :inline="true">
        <el-form-item label="年份" label-width="50px">
          <el-date-picker
            v-model="year"
            type="year"
            size="mini"
            format="yyyy"
            placeholder="选择年"
            value-format="yyyy"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="课题名称" prop="name" label-width="80px">
          <el-input
            v-model="courseName"
            size="small"
            style="width: 150px"
            clearable
          ></el-input>
        </el-form-item>
        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList()"
            >查询</el-button
          >
          <el-button
            icon="el-icon-download"
            size="small"
            type="warning"
            @click="handleExport()"
            style="margin-left: 15px"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>
    <div>
      <el-table
        :data="allTrackResult"
        fit
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
        :max-height="height"
      >
        <el-table-column
          label="课题编号"
          align="center"
          prop="courseId"
          sortable
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="课题名称"
          align="left"
          prop="courseName"
          min-width="200px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="项目类型"
          align="left"
          prop="courseType"
          min-width="100px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="课题负责人"
          align="left"
          prop="courseLeaderName"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="课题评分"
          align="left"
          prop="score"
          min-width="150px"
          sortable
          :show-overflow-tooltip="true"
        />
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <el-dialog
        :visible.sync="detailOpen"
        :title="detailTitle"
        width="750px"
        :modal-append-to-body="false"
        append-to-body
      >
        <el-input
          v-model="detail"
          style="width: 700px"
          type="textarea"
          :rows="15"
          :readonly="true"
        />
      </el-dialog>
    </div>
  </div>
</template>
  
  <script>
import { resultScoreList, exportScoreList } from "@/api/trackMonth.js";
export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0,
      courseGroup: "",
      year: new Date().getFullYear().toString(),
      courseName: "",
      allTrackResult: [{}],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      detail: "",
      detailOpen: false,
      detailTitle: "",
      height: 100,
    };
  },

  created() {
    this.getList();
  },
  methods: {
    getList() {
      resultScoreList(
        this.year,
        this.courseName,
        this.page,
        this.pageSize
      ).then((res) => {
        if (res.code == 0) {
          this.allTrackResult = res.data;
          this.total = res.count;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 135;
        }
      });
    },
    detailed(detial, detailTitle) {
      this.detailOpen = true;
      this.detailTitle = detailTitle;
      this.detail = detial;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    handleExport() {
      exportScoreList(this.year, this.courseName).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>
  
  <style>
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
</style>